import React, {useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';

const Header = () => {
    const navigate = useNavigate();
    const [, setActiveSection] = useState('');

    // Smooth scroll for same-page sections
    const handleScroll = (e, sectionId) => {
        e.preventDefault();
        setActiveSection(sectionId);

        // Check if we're on homepage
        if (window.location.pathname === '/') {
            // Already on homepage - just scroll
            const element = document.getElementById(sectionId);
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        } else {
            // Navigate to homepage with hash
            navigate(`/#${sectionId}`);
        }
    };

    return (
        <header id="home" className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
            <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
                {/* Logo - Always to homepage */}
                <Link to="/#hero" className="flex items-center gap-3 group">
                    <img
                        src="/images/logo.png"
                        alt="Frelish Yogurt Logo"
                        className="w-35 h-10 object-contain"
                        onClick={(e) => handleScroll(e, 'hero')}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "https://cdn-icons-png.flaticon.com/512/1141/1141149.png";
                        }}
                    />
                </Link>

                {/* Navigation */}
                <nav className="hidden md:flex items-center gap-8">
                    {/* PRODUCTS - Page Link */}
                    <a
                        href="/#products"
                        onClick={(e) => handleScroll(e, 'products')}
                        className="text-gray-700 hover:text-[#DE0000] transition-colors font-medium"
                    >
                        Products
                    </a>

                    {/* SUSTAINABILITY - Same-page smooth scroll */}
                    <a
                        href="/#brand"
                        onClick={(e) => handleScroll(e, 'brand')}
                        className="text-gray-700 hover:text-[#DE0000] transition-colors font-medium"
                    >
                        Sustainability
                    </a>

                    {/* OUR STORY - Same-page smooth scroll */}
                    <a
                        href="/#about"
                        onClick={(e) => handleScroll(e, 'about')}
                        className="text-gray-700 hover:text-[#DE0000] transition-colors font-medium"
                    >
                        Our Story
                    </a>

                    {/* CONTACT - Same-page smooth scroll */}
                    <a
                        href="/#contact"
                        onClick={(e) => handleScroll(e, 'contact')}
                        className="text-gray-700 hover:text-[#DE0000] transition-colors font-medium"
                    >
                        Contact
                    </a>
                </nav>

                {/* CTA Buttons */}
                {/*<div className="flex items-center gap-4">
                    <a
                        href="https://share.google/uz0dFnOS7MzPhnzCM"
                        className="hidden md:block text-[#DE0000] font-medium hover:text-[#3d6f5b] transition-colors"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Store Locator
                    </a>
                    <Link
                        to="/products"
                        className="bg-[#DE0000] text-white px-6 py-2.5 rounded-full font-medium hover:bg-[#b30000] transition-all hover:shadow-lg hover:scale-105"
                    >
                        Shop Now
                    </Link>
                </div>*/}
            </div>
        </header>
    );
};

export default Header;